import React, { useContext, useEffect, useState } from 'react'
import { Button } from '@mui/material'
import { useHistory } from 'react-router-dom'
import Layout from '../../product/components/templates/Layout'
import commonContext from '../../product/context/product/productContext'
import './SyncDashboard.css'
import Loaders from '../../product/components/molecules/Loaders'
import { useFormik } from 'formik'
import CustomSearch from '@/product/components/molecules/CustomSearch'

const Dashboard = () => {
    const history = useHistory()
    const [isLoading, setIsLoading] = useState(true)
    const [loaded, setLoaded] = useState(0)

    const dashboardContext = useContext(commonContext)
    const { getSyncDashboardNetsuiteData, mainDashboardSync } = dashboardContext
    const [getdashboard, setDashboard] = useState({
        activeCount: 0,
        draftCount: 0,
        soldbuynowCount: 0,
        unsoldCount: 0,
    })

    const formik = useFormik({
        initialValues: {
            fromDate: '',
            toDate: '',
        },
        onSubmit: (values) => {
            setIsLoading(true)
            getSyncDashboardNetsuiteData(values)
        },
    })

    useEffect(() => {
        console.log('TEST LOADING OUTSIDE', loaded)
        if (loaded) {
            console.log('TEST LOADING INSIDE', loaded)
            setIsLoading(true)
            getSyncDashboardNetsuiteData()
            setLoaded(1)
        } else {
            setLoaded(1)
        }
    }, [loaded])

    const searchInfo = {
        formik: formik,
        data: [
            {
                label: 'Date',
                placeholder: 'Date',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'date',
                name: 'currentDate',
            },
        ],
    }

    useEffect(() => {
        setIsLoading(false)
        console.log('mainDashboardSyncmainDashboardSync', mainDashboardSync)
        // if (Object.keys(mainDashboardSync).length > 0) {
        //     console.log('sathis', mainDashboardSync)
        //     setDashboard(mainDashboardSync)
        // }
    }, [mainDashboardSync])

    return (
        <Layout>
            <div className="dashboard">
                <div className="dashboard listing">
                    <CustomSearch searchInfo={searchInfo} formik={formik} />
                </div>
                <div className="syncDashboardCnt">
                    <div className="syncDashboardCard">
                        <div className="sdInner">
                            <div className="sdLt">
                                <h6>NetSuite</h6>
                                <img
                                    className="statusTypeIcon"
                                    src="/assets/svg/update.svg"
                                    alt="Update icon"
                                />
                                <h5>
                                    {
                                        mainDashboardSync.third_party_prdtCount
                                            .active
                                    }
                                </h5>
                            </div>
                            <div className="sdRt">
                                <h6>AuctionSoftware</h6>
                                <img
                                    className="statusTypeIcon"
                                    src="/assets/svg/update.svg"
                                    alt="Update icon"
                                />
                                <h5>{mainDashboardSync.productCount.active}</h5>
                            </div>
                            <img
                                className="arrowsIcon"
                                src="/assets/svg/arrows.svg"
                                alt="Arrows svg"
                            />
                        </div>
                        <div className="sdStatus">
                            <p>Added / Updated Records</p>
                            <span className="material-icons statusGo">
                                check_circle
                            </span>
                            {/* <span className="material-icons statusFail">warning</span> */}
                        </div>
                    </div>
                    <div className="syncDashboardCard">
                        <div className="sdInner">
                            <div className="sdLt">
                                <h6>NetSuite</h6>
                                <img
                                    className="statusTypeIcon"
                                    src="/assets/svg/delete.svg"
                                    alt="Update icon"
                                />
                                <h5>
                                    {
                                        mainDashboardSync.third_party_prdtCount
                                            .removed
                                    }
                                </h5>
                            </div>
                            <div className="sdRt">
                                <h6>AuctionSoftware</h6>
                                <img
                                    className="statusTypeIcon"
                                    src="/assets/svg/delete.svg"
                                    alt="Update icon"
                                />
                                <h5>
                                    {mainDashboardSync.productCount.removed}
                                </h5>
                            </div>
                            <img
                                className="arrowsIcon"
                                src="/assets/svg/arrows.svg"
                                alt="Arrows svg"
                            />
                        </div>
                        <div className="sdStatus">
                            <p>Removed Records</p>
                            <span className="material-icons statusGo">
                                check_circle
                            </span>
                            {/* <span className="material-icons statusFail">warning</span> */}
                        </div>
                    </div>
                </div>
                <div
                    className="syncStatusBanner statusGo"
                    style={{ display: 'none' }}
                >
                    {/* Change the className to "statusFail" in case of a negative scenario. */}
                    <h6>
                        Everything looks good. All records have been
                        synced.{' '}
                    </h6>
                    {/* <h6>
                        There is a mismatch of data while syncing between
                        NetSuite and AuctionSoftware!
                    </h6> */}
                    <span className="material-icons">check_circle</span>
                    {/* <span className="material-icons">warning</span> */}
                </div>
            </div>
        </Layout>
    )
}

export default Dashboard
